import ProgressIndicatorWrapper from "../ProgressIndicatorWrapper";
import { SIZE_MEDIUM } from "@asosteam/asos-web-component-library-progress-indicator";

const ProductTileProgressIndicatorWrapper = props => (
  <ProgressIndicatorWrapper {...props} size={SIZE_MEDIUM} />
);

export default ProductTileProgressIndicatorWrapper;
